export default "__VITE_ASSET__CmA6lgmT__"